var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","max-width":"1200px"}},[_c('Player',{attrs:{"video":_vm.video.src},on:{"timeupdate":function (time) { return this$1.time = time; }}},[_c('Overlay',{attrs:{"slot":"overlay","tags":_vm.video.tags,"time":_vm.time},slot:"overlay"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }